import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import filesize from 'filesize';
import _ from 'lodash';

import MediaType, {getFileMediaUrl} from '@/page/app/MediaPage/MediaType';
import NewsLikeContent from './comp/NewsLikeContent';
import VideoFormModal from '@/page/component/VideoFormModal';
import VideoPreview from '@/page/component/VideoFormModal/VideoPreview';

import {valuePropTypes} from '@/page/app/component/MessageContent/content/propTypes';
import Player from "@/page/component/Player";

export default function VideoContent({value, onChange}) {
    const videoFormModalRef = useRef();
    const playerRef = useRef();

    function onAddClick() {
        videoFormModalRef.current.showModal();
    }

    function onEditClick() {
        videoFormModalRef.current.showModal(value);
    }

    function onFormSuccess(values) {
        onChange && onChange(values);
        return true;
    }

    function onNameClick(record) {
        const {title, description, attachId, attachExt} = record;
        const url = getFileMediaUrl(attachId, attachExt);

        playerRef.current.showPlayer('video', title, url, description);
    }

    return (
        <>
            <NewsLikeContent
                hasValue={!_.isEmpty(value)}
                buttonTitle="添加视频"
                description={
                    <>
                        <p>格式支持: {MediaType.VIDEO.accept}</p>
                        <p>文件大小不超过 {filesize(MediaType.VIDEO.maxSize)}</p>
                    </>
                }
                onAddClick={onAddClick}
                onEditClick={onEditClick}
                onChange={onChange}
                type="video"
            >
                <VideoPreview videoData={value} onPlay={onNameClick} />
            </NewsLikeContent>

            <Player ref={playerRef} />

            <VideoFormModal
                ref={videoFormModalRef}
                category="message"
                onFormSuccess={onFormSuccess}
            />
        </>
    );
}

VideoContent.propTypes = {
    value: valuePropTypes,
    onChange: PropTypes.func.isRequired,
};
